import { call, put, takeLatest } from "redux-saga/effects";
import { studentAPI } from "../../../services/student/index"
import { getStudentId, GET_STUDENTID} from "../../actions/student.action"

function* handleFetchStudentID(action) {
  try {
    const { data : resData} = yield call(studentAPI.fetchStudentID, action.payload);
    //extract the data here     
    yield put(getStudentId.success({
      data:resData?.data
  }));
  } catch (e) {
    const {data:resData} = e
    yield put(getStudentId.failure({
      data:resData?.data
  }));
  }
}

function* fetchStudentIDSaga() {
  yield takeLatest(GET_STUDENTID.REQUEST, handleFetchStudentID);
}

export default fetchStudentIDSaga;
